import React, { useEffect, useState } from 'react';
import './StarsAnimation.css';

// Soft pastel colors matching the site aesthetic
const PASTEL_COLORS = [
  '#E6B3C2', // dusty rose
  '#F2C6A0', // peach
  '#D4C4E0', // lavender
  '#C9D3B8', // sage
  '#F4EDE4', // cream
  '#E8D4C4', // warm beige
];

export default function StarsAnimation({ isActive, onComplete }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (!isActive) {
      setParticles([]);
      return;
    }

    // Generate soft floating particles in a gentle dispersal pattern
    const newParticles = [];
    const numParticles = 20;

    for (let i = 0; i < numParticles; i++) {
      // Gentle floating pattern - particles drift outward and upward
      const angle = (i / numParticles) * Math.PI * 2 + Math.random() * 0.5;
      const distance = 15 + Math.random() * 40;

      // Randomize starting position slightly around the banner
      const startXOffset = (Math.random() - 0.5) * 20;

      newParticles.push({
        id: i,
        color: PASTEL_COLORS[Math.floor(Math.random() * PASTEL_COLORS.length)],
        startX: 50 + startXOffset,
        startY: 8 + Math.random() * 5, // Near the banner
        endX: 50 + Math.cos(angle) * distance + startXOffset,
        endY: 8 + Math.sin(angle) * distance * 0.5 - Math.random() * 15, // Drift upward
        delay: i * 40 + Math.random() * 100,
        duration: 1200 + Math.random() * 600,
        size: 4 + Math.random() * 8,
        opacity: 0.4 + Math.random() * 0.4,
        blur: Math.random() > 0.5, // Some particles are blurred for depth
      });
    }

    setParticles(newParticles);

    // Clear after animation completes
    const timeout = setTimeout(() => {
      setParticles([]);
      onComplete?.();
    }, 2200);

    return () => clearTimeout(timeout);
  }, [isActive, onComplete]);

  if (particles.length === 0) return null;

  return (
    <div className="stars-animation-container">
      {particles.map((particle) => (
        <span
          key={particle.id}
          className={`nostalgic-particle ${particle.blur ? 'blurred' : ''}`}
          style={{
            '--start-x': `${particle.startX}vw`,
            '--start-y': `${particle.startY}vh`,
            '--end-x': `${particle.endX}vw`,
            '--end-y': `${particle.endY}vh`,
            '--delay': `${particle.delay}ms`,
            '--duration': `${particle.duration}ms`,
            '--size': `${particle.size}px`,
            '--color': particle.color,
            '--opacity': particle.opacity,
          }}
        />
      ))}
    </div>
  );
}
